module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElementLayout', {
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    }
  }, [_vm._v("\n     \n    "), _c('v-btn', {
    staticStyle: {
      "margin": "10px 0 10px 0"
    },
    attrs: {
      "slot": "right",
      "color": "primary"
    },
    on: {
      "click": _vm.run
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.element.title))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18a1d0fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/controls/ButtonControl.vue
// module id = 2465
// module chunks = 1